import { NestedQuota } from '../../../shared/interfaces/quota.interface';

export class AllocatedNestedQuota {
  constructor(private readonly _quota: NestedQuota) {}

  public quota(): NestedQuota {
    return this._quota;
  }

  public allocation(): number {
    return this._quota.required_count || this._quota.number || 0;
  }

  public percentage(): number {
    return this._quota.percentage || 0;
  }

  public add(value: number): void {
    if (this._quota.number) {
      this._quota.number += value;
      this._quota.required_count = this._quota.number;
      return;
    }

    if (this._quota.required_count) {
      this._quota.required_count += value;
      this._quota.number = this._quota.required_count;
      return;
    }

    this._quota.required_count = value;
    this._quota.number = value;
  }
}
